import { render } from "./user-info.vue?vue&type=template&id=b113a730"
import script from "./user-info.vue?vue&type=script&lang=js"
export * from "./user-info.vue?vue&type=script&lang=js"

import "./user-info.vue?vue&type=style&index=0&id=b113a730&lang=postcss"
script.render = render

export default script